export const getCardTypeDetails = ({ cardType }) => {
  const cardDetails = [
    "Free delivery",
    "Gift cards cannot be used to purchase other gift cards"
  ];

  const deliveryAndRedemption = [];

  if (cardType.electronic_online) {
    deliveryAndRedemption.push("This eGift card can be redeemed online.");
  }

  if (cardType.electronic_voucher) {
    deliveryAndRedemption.push(
      "This printable voucher can be redeemed on location."
    );
  }

  if (cardType.electronic_voucher || cardType.electronic_online) {
    deliveryAndRedemption.push(
      "Most eGift cards and printable vouchers are delivered to your GCX account instantly, but please allow up to 24 hours."
    );
  }

  deliveryAndRedemption.push(cardType.instructions);

  return { cardDetails, deliveryAndRedemption };
};
